import * as React from "react";
import {useState} from "react";
import {IconButton, Switch, TableCell, TableRow, Tooltip} from "@mui/material";
import {BiArchiveIn, BiArchiveOut} from "react-icons/bi";
import {FiEdit} from "react-icons/fi";
import {GrTextAlignFull} from "react-icons/gr";
import StaffSponsorPostcodes from "./StaffSponsorPostcodes";
import StaffSponsorsAddSponsorCode from "./StaffSponsorsAddSponsorCode";
import FunctionsData from "../../../Functions/FunctionsData";

export default function StaffSponsorsShowTableRow({
  row, refresh, setRefresh, setLoading, tags, idx, updateSponsors,
  // NEW prop
  vouchersStats
}) {

  const [isOpenRow, setIsOpenRow] = React.useState(false);
  const [isLoadingImage, setIsLoadingImage] = React.useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function getFunding() {
    return (
      (row.sponsor_surgery_amount) + (row.microchip_extra_cost * row.sponsor_microchip_added)
    );
  }

  function getFundingPercent() {
    return (
      (getFunding() / row.max_spent * 100).toFixed(1)
    )
  }

  const submitFile = async (acceptedFiles) => {
    setIsLoadingImage(true);
    try {
      const fileNameOriginal = acceptedFiles[0].name;
      const ext = fileNameOriginal.split('.').pop().toLowerCase();
      if (!(['png', 'gif', 'jpeg', 'jpg', 'tiff'].includes(ext))) {
        setErrorMessage('Not allowed');
        return false;
      }

      const formData = new FormData();
      formData.append('file', acceptedFiles[0]);

      await fetch(FunctionsData.getApiUrl('/api/file/sponsor/') + row.id, {
        method: 'POST',
        body: formData
      })
        .then(() => {
          setTimeout(() => {
            setLoading(true)
            setIsLoadingImage(false);
          }, 2000)
        })
        .catch((e) => {
          setIsLoadingImage(false);
          console.log('file upload error', e);
        });
    } catch (error) {
      setIsLoadingImage(false);
      console.log('file upload error', error);
    }
  };

  if (isLoadingImage) return "Loading image";

  const { provisioned = 0, issued = 0, redeemed = 0, available = 0 } = vouchersStats || {};

  return (
    <>
      <TableRow key={Date.now() - idx}>
        <TableCell sx={{width: '50px'}} align="center">
          <Switch
            checked={(row.active > 0)}
            onChange={(e) => updateSponsors('active', e.target.checked, row.id)}
          />
        </TableCell>
        <TableCell>
          <img src={row.logo} style={{height: 30}} alt="logo"/>
          <div><input type={"file"} multiple={false} onChange={(e) => submitFile(e.target.files)}/></div>
        </TableCell>
        <TableCell align="left">
          {row.name}{" "}
          <a href={""} onClick={(e) => { e.preventDefault(); setIsOpenRow(true) }}>
            <FiEdit size={15}/>
          </a>
        </TableCell>
        <TableCell align="left">
          {row.program}
          <Tooltip title={row.email_text}>
            <IconButton size={"small"}>
              <GrTextAlignFull/>
            </IconButton>
          </Tooltip>
        </TableCell>
        <TableCell align="left" style={{color: (row.max_spent < getFunding()) ? 'red' : 'green'}}>
          <div style={{whiteSpace: 'nowrap'}}>
            ${numberWithCommas(row.max_spent - getFunding())} available
          </div>
          <div style={{whiteSpace: 'nowrap'}}>
            ${numberWithCommas(getFunding())} / ${numberWithCommas(row.max_spent)}
          </div>
          <div>{getFundingPercent()}%</div>
        </TableCell>
        <TableCell align="left">
          ${row.applicant_cost}
        </TableCell>
        <TableCell align="left">
          <StaffSponsorPostcodes tags={tags} row={row}/>
        </TableCell>
        <TableCell align="left">
          {new Date(String(row.start_date)).toLocaleDateString('en-NZ')}
        </TableCell>
        <TableCell align="left">
          {new Date(String(row.end_date)).toLocaleDateString('en-NZ')}
        </TableCell>

        <TableCell align="left" sx={{whiteSpace: 'nowrap'}}>
          <div style={{fontSize: 12, lineHeight: 1.4}}>
            {/* <div><strong>{provisioned}</strong> provisioned</div> */}
            <div><strong>{issued}</strong> issued</div>
            <div><strong>{redeemed}</strong> redeemed</div>
            <div><strong>{available}</strong> available</div>
          </div>
        </TableCell>

        <TableCell align="center">
          {(row.archived > 0) ? (
            <a href={""}
               onClick={(e) => { e.preventDefault(); updateSponsors('archived', 0, row.id); }}>
              <BiArchiveOut size={30}/>
            </a>
          ) : (
            <a href={""}
               onClick={(e) => { e.preventDefault(); updateSponsors('archived', 1, row.id); }}>
              <BiArchiveIn size={30}/>
            </a>
          )}
        </TableCell>
      </TableRow>

      {(isOpenRow === true) ? (
        <StaffSponsorsAddSponsorCode
          setLoading={setLoading}
          setIsOpen={setIsOpenRow}
          isOpen={isOpenRow}
          currentData={row}
          mode={"update"}
          key={idx}
        />
      ) : undefined}
    </>
  )
}
